import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'ayen-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent  implements OnInit{

  @Output() pageData = new EventEmitter();
  @Output() pageSize = new EventEmitter();
  @Output() pageChange = new EventEmitter();
  @Input() totalCount = 0;
  @Input() id = 'myPagination';
  @Input() pageTitle = '';
  @Input() itemsPerPage = 0;
  @Input() currentPage = 0;
  pageSizeValues: number[] = [20,25,50,75,100]
  selectedItem: number = this.pageSizeValues[0];
  totalPage;
  myForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.myForm = this.fb.group({
      page: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.setDataForSelectSizePage()
    this.setTotalPage(this.itemsPerPage)
  }

  pageChanged(event) {
    this.pageData.emit(event)
    this.myForm.patchValue({
      page: event,
    });
  }

  pageSizeChanged(event) {
   this.pageSize.emit(event);
   this.setTotalPage(event)
  }
  
  setTotalPage(pageSize) {
    if (!pageSize || pageSize <= 0) return;

    const count = Number(this.totalCount) || 0;
    const size = Number(pageSize);
    const totalPages = Math.ceil(count / size);
  
    this.totalPage = totalPages;
  
    this.myForm.patchValue({
      page: this.currentPage,
    });
  }

  setDataForSelectSizePage() {
    let index = this.pageSizeValues.findIndex((item) => {
      return item === this.itemsPerPage
    });
    if (index === -1) {
      this.pageSizeValues.push(this.itemsPerPage);
      this.pageSizeValues.sort((a, b) => a - b);
      this.selectedItem = this.itemsPerPage;
    } else {
      this.selectedItem = this.pageSizeValues[index];
    }
  }

  onSubmit() {
    if (this.myForm.valid) {
      this.pageChange.emit(this.myForm.value.page);
    }
  }

}
